<template>
  <div>
    <div id="printTable">
      <Form ref="formDynamic" :model="formDynamic" :label-width="50">
        <List border size="small">
          <ListItem>
            <Col span="3">采购工单编号:</Col>
            <Col span="19">{{ procurementNum }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">事由:</Col>
            <Col span="19">{{ shiyou }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">期望交付日期:</Col>
            <Col span="19">{{ jiaofuData }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">收货信息:</Col>
            <Col span="19">{{ shouhuoInfo }}</Col>
          </ListItem>
        </List>
        <!-- 表格 -->
        <h4 style="margin: 10px 0">明细:</h4>
        <Row>
          <Col span="24">
            <Table
              :columns="tableCols"
              :data="data2"
              :table="table"
              :border="table.border"
              :stripe="table.stripe"
              :header="table.header"
              :footer="table.footer"
              :columns-list="tableCols"
            >
            </Table
          ></Col>
        </Row>

        <Row style="margin-top: 5px">
          <Col>
            <h3 class="zong">总价:{{ zongjia }}元</h3>
          </Col>
        </Row>
        <Row style="margin-top: 5px">
          <Col>
            <h3 class="zong" style="display: inline">优惠后总价:</h3>
          </Col>
          <Col>
            <InputNumber :min="0" v-model="endTotalPrice" />
          </Col>
        </Row>
        <h4 style="margin-bottom: 5px">备注:</h4>
        <Input
          v-model="procurementOpinions"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 2 }"
        ></Input>
      </Form>
    </div>
    <Form
      ref="formDynamic"
      :model="formDynamic"
      :label-width="80"
      style="width: 1100px; margin-top: 30px"
    >
      <FormItem>
        <Button type="primary" @click="handleSubmit()">保存订单</Button>
        <Button style="margin-left: 10px" type="primary" v-print="printObject"
          >打印订单</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  props: {
    item: "",
  },
  data() {
    return {
      printObject: {
        id: "printTable",
        popTitle: "采购订单", // 打印配置页上方的标题
      },
      endTotalPrice: 0,
      procurementOpinions: "",
      zongjia: 0,
      userTotalPrice: 0,
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      num: "",
      procurementNum: "",
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 275,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "150px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "公/本仓",
          key: "text",
          minWidth: 65,
          align: "center",
        },
        {
          title: "申请数",
          key: "alertNum",
          minWidth: 60,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "jdPrice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.jdPrice ? row.jdPrice.toFixed(2) : 0;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "采购数",
          key: "adminAlertNum",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return h(
              "InputNumber",
              {
                props: {
                  min: 1,
                  value: row.adminAlertNum,
                },
                on: {
                  "on-change": (event) => {
                    this.obj.sysProcurementDetails[params.index].adminAlertNum = event;
                    this.getzongjia(this.obj.sysProcurementDetails);
                  },
                },
                style: {
                  width: "60px",
                },
              },
              row.adminAlertNum
            );
          },
        },
        {
          title: "折扣率",
          key: "discountRate",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return h(
              "InputNumber",
              {
                props: {
                  min: 0,
                  max: 1,
                  value: row.discountRate,
                  step: 0.1,
                },
                on: {
                  "on-change": (event) => {
                    this.obj.sysProcurementDetails[params.index].discountRate = event;
                    this.getzongjia(this.obj.sysProcurementDetails);
                  },
                },
                style: {
                  width: "60px",
                },
              },
              row.discountRate
            );
          },
        },
        {
          title: "折后价",
          key: "Discountedprice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.Discountedprice;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
      ],
      obj: {},
      q: {},
      typearr: [],
      selectList: [],
    };
  },
  async created() {
    await this.info();
    await this.type();
  },
  methods: {
    async info() {
      let id = this.item;
      let res = await $utils.api.load(`/admin/system/procurementWork/${id}`);
      if (res.code == 200) {
        let arr = res.data.sysProcurementDetails;
        this.obj = res.data;
        this.shiyou = res.data.becauseWork;
        if (res.data.needTime) {
          var date = res.data.needTime;
          this.jiaofuData = date.split("T")[0];
        }
        this.procurementNum = res.data.procurementNum;
        this.shouhuoInfo = res.data.receivingInformation;
        for (let i = 0; i < arr.length; i++) {
          let obj = {};
          obj.consumableNum = arr[i].consumableNum;
          obj.consumableImgUrl = arr[i].consumableImgUrl;
          obj.brand = arr[i].brand;
          obj.name = arr[i].name;
          obj.model = arr[i].model;
          obj.remark = arr[i].remark;
          obj.num = arr[i].num;
          obj.id = arr[i].id;
          obj.unit = arr[i].unit;
          obj.alertNum = arr[i].alertNum;
          obj.consumableUuid = arr[i].consumableUuid;
          obj.unitPrice = arr[i].unitPrice;
          obj.jdPrice = arr[i].jdPrice;
          obj.adminAlertNum = arr[i].adminAlertNum == null ? 0 : arr[i].adminAlertNum;
          obj.typeId = arr[i].typeId ? arr[i].typeId : "";
          let ownNum = arr[i].ownNum == null ? 0 : arr[i].ownNum;
          let adminNum = arr[i].adminNum == null ? 0 : arr[i].adminNum;
          obj.text = adminNum + "/" + ownNum;
          obj.discountRate = arr[i].discountRate == null ? 1 : arr[i].discountRate;
          obj.Discountedprice = 0;
          obj.index = i;
          this.data2.push(obj);
        }
        this.obj.sysProcurementDetails = this.data2;
        this.getzongjia(this.obj.sysProcurementDetails);
      }
    },
    getzongjia(list) {
      this.zongjia = 0; // 总价
      this.userTotalPrice = 0; // 用户总价

      for (let i = 0; i < list.length; i++) {
        let num = list[i].adminAlertNum; // 当前物资的采购数
        let discountRate = list[i].discountRate; // 当前物资的折扣率
        let Price = list[i].unitPrice; // 后台单价
        let UnitPrice = list[i].jdPrice; // 用户单价
        // 计算当前物资的折后价
        let discountedPrice = UnitPrice * discountRate * num;
        // 更新当前物资的折后价
        list[i].Discountedprice = discountedPrice.toFixed(2);
        // 累加总价和用户总价
        this.zongjia += Price * discountRate * num;
        this.userTotalPrice += UnitPrice * discountRate * num;
      }
      // 更新总价格和用户总价格
      this.zongjia = this.zongjia.toFixed(2);
      this.userTotalPrice = this.userTotalPrice.toFixed(2);
      this.endTotalPrice = this.userTotalPrice; // 优惠后总价
    },
    async type() {
      let arr = this.data2;
      let res = await $utils.api.load(`/admin/system/consumableType/selectList`);
      if (res.code == 200) {
        let list = res.rows;
        for (let a = 0; a < arr.length; a++) {
          const item = arr[a];
          let typelist = [];
          for (let i = 0; i < list.length; i++) {
            let type = {};
            const item1 = list[i];
            type.model = item1.model;
            type.id = item1.id;
            typelist.push(type);
            this.selectList = typelist;
            item.typelist = typelist;
          }
        }
      }
    },
    async handleSubmit() {
      let q = this.obj;
      q.state = 3;
      q.procurementOpinions = this.procurementOpinions;
      q.endTotalPrice = this.endTotalPrice;
      let res = await $utils.api.load("/admin/system/procurementWork/edit", q, "post");
      if (res.code == 200) {
        await $utils.toast.success("采购成功");
        this.$Modal.remove();
        setTimeout(function () {
          $utils.url.go(0);
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
.ivu-input {
  color: red !important;
}
</style>
